module.exports = __webpack_public_path__ + "img/option_c.b58beb7f.png";